module.exports = new __parcel__URL__("step_three_vector_light.c27f5a05.png").toString();